export default __webpack_public_path__ + "static/media/Piticas.df5aa89d.jpg";